import script from "./MessageCompose.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageCompose.vue?vue&type=script&setup=true&lang=js"

import "./MessageCompose.vue?vue&type=style&index=0&id=7b749310&scoped=true&lang=css"

import exportComponent from "E:\\cymcorp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b749310"]])

export default __exports__